"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Clock, FileText } from "lucide-react";

interface TimeLog {
  id: string;
  tasks?: { title: string };
  task?: { title: string };
  duration_minutes: number;
  start_time?: string;
  date?: string;
}

interface ClientTimeReportsProps {
  time_logs: TimeLog[];
}

const ClientTimeReports: React.FC<ClientTimeReportsProps> = ({ time_logs }) => {
  const totalHours = Math.round(time_logs.reduce((sum: number, log: TimeLog) => sum + (log.duration_minutes || 0), 0) / 60);

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <Clock className="h-4 w-4" />
            <span>Time Reports</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="mb-4">
            <p className="text-lg font-bold">Total Time: {totalHours}h</p>
          </div>
          {time_logs.length === 0 ? (
            <p className="text-muted-foreground">No time logs yet.</p>
          ) : (
            <div className="space-y-2">
              {time_logs.map((log) => (
                <div key={log.id} className="p-3 border rounded">
                  <div className="font-medium">{log.tasks?.title || log.task?.title || 'General Work'}</div>
                  <p className="text-sm text-muted-foreground">
                    {log.duration_minutes} minutes on {new Date(log.date || log.start_time || Date.now()).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientTimeReports;